import CameraIcon from '@assets/icons/camera.svg';
import DownloadIcon from '@assets/icons/download.svg';
import i18n from '@/utils/i18n';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { Position } from '@/contexts/toast-context';
import { Text, TouchableOpacity, View } from 'react-native';
import { theme, TYPOGRAPHY } from '@/styles';
import { useRequestCamera } from '@/hooks/use-request-camera';

interface Props {
  onClose: () => void;
  onNavigateToMenuCameraScreen: () => void;
  onNavigateToViewMenu: () => void;
  showOnlineMenuOption: boolean;
  showTakePictureOption: boolean;
}

export const MenuOptionsActionSheet = ({
  onClose,
  onNavigateToMenuCameraScreen,
  onNavigateToViewMenu,
  showOnlineMenuOption,
  showTakePictureOption,
}: Props) => {
  const [styles] = useStyles();
  const { requestCamera } = useRequestCamera();

  return (
    <BaseActionSheet isVisible onClose={onClose} toastPosition={Position.TOP}>
      <Text style={[TYPOGRAPHY.pSemiBold, styles.title]}>
        {i18n.t('menu_camera.create_order_guide')}
      </Text>
      <View style={styles.base}>
        {showOnlineMenuOption ? (
          <TouchableOpacity
            onPress={() => {
              onNavigateToViewMenu();
              onClose();
            }}
            style={styles.row}
          >
            <DownloadIcon
              height={24}
              stroke={theme.colors.primary}
              width={24}
            />
            <Text style={TYPOGRAPHY.listTitle}>
              {i18n.t('menu_camera.online_menu')}
            </Text>
          </TouchableOpacity>
        ) : null}
        {showTakePictureOption ? (
          <TouchableOpacity
            onPress={async () => {
              const permissionResponse = await requestCamera();
              if (permissionResponse === 'granted') {
                onNavigateToMenuCameraScreen();
                onClose();
              }
            }}
            style={styles.row}
          >
            <CameraIcon height={22} stroke={theme.colors.primary} width={22} />
            <Text style={TYPOGRAPHY.listTitle}>
              {i18n.t('menu_camera.use_photos')}
            </Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles(() => ({
  base: {
    paddingHorizontal: 4,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 12,
    paddingVertical: 16,
  },
  title: {
    fontSize: 25,
    lineHeight: 25,
    paddingBottom: 12,
  },
}));
